import { forwardRef, type Ref, type SVGProps } from "react";
const IconPlusOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M29 15H17V3a1 1 0 0 0-2 0v12H3a1 1 0 0 0 0 2h12v12a1 1 0 0 0 2 0V17h12a1 1 0 0 0 0-2" /></svg>;
const ForwardRef = forwardRef(IconPlusOutlineSVG);
ForwardRef.displayName = "IconPlusOutline";
export { ForwardRef as IconPlusOutline };